export function getRotatedRectangleGeometry({ x, y, w, h, rotation = 0, }) {
    const angle = ((rotation % 360) * Math.PI) / 180;
    const rawCos = Math.cos(angle);
    const rawSin = Math.sin(angle);
    const cos = Math.abs(rawCos) < 1e-12 ? 0 : rawCos;
    const sin = Math.abs(rawSin) < 1e-12 ? 0 : rawSin;
    const cx = x + w / 2;
    const cy = y + h / 2;
    const rotate = (dx, dy) => ({
        x: cx + dx * cos - dy * sin,
        y: cy + dx * sin + dy * cos,
    });
    const corners = [
        rotate(-w / 2, -h / 2),
        rotate(w / 2, -h / 2),
        rotate(w / 2, h / 2),
        rotate(-w / 2, h / 2),
    ];
    const left = Math.min(...corners.map((point) => point.x));
    const top = Math.min(...corners.map((point) => point.y));
    return {
        bounds: {
            x: left,
            y: top,
            w: Math.max(...corners.map((point) => point.x)) - left,
            h: Math.max(...corners.map((point) => point.y)) - top,
        },
        corners,
    };
}
